import { loader } from "routes/data-routes/billing-data/pricing-options/loader";
import { action } from "routes/data-routes/billing-data/pricing-options/action";
import {
  PricingOptionsDataRoutePath,
  PricingOptionsDataRouteType
} from "routes/data-routes/billing-data/pricing-options/route.meta";
import { usePricingOptions as hook } from "routes/data-routes/billing-data/pricing-options/usePricingOptions";


const PricingOptionsDataRouteDefinition: PricingOptionsDataRouteType = {
  route: {
    path: PricingOptionsDataRoutePath,
    loader,
    action,
    shouldRevalidate: () => false
  },
  usePricingOptions: hook
};

export const { route: PricingOptionsDataRoute, usePricingOptions } = PricingOptionsDataRouteDefinition;
